import { FC } from 'react';
import './TransparencyAboutComponent.scss';
import { TRANSPARENCY_ABOUT_LABELS } from './model';

const TransparencyAboutComponent: FC = () => {
	return (
		<div className='transparency-about-container'>
			<h2 className='section-title'>{TRANSPARENCY_ABOUT_LABELS.title}</h2>
			<p className='transparency-content'>{TRANSPARENCY_ABOUT_LABELS.content}</p>
		</div>
	);
};

export default TransparencyAboutComponent;
